var React = require('react');

function Size (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.79 16.5H.21v-1l27.58-12z","fill":"#333","opacity":".4","id":"Layer_1"}));
}

Size.defaultProps = {"viewBox":"0 0 28 20"};

module.exports = Size;

Size.default = Size;
